import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Track page view
    axios.post(`${API}/analytics/track`, {
      event: 'page_view',
      page: location.pathname,
      referrer: document.referrer,
    }, { withCredentials: true }).catch(() => {});
  }, [location.pathname]);
}

export function trackEvent(event, data = {}) {
  axios.post(`${API}/analytics/track`, {
    event,
    page: window.location.pathname,
    ...data,
  }, { withCredentials: true }).catch(() => {});
}
